module.exports = __webpack_public_path__ + "assets/img/14_901_big.3d69d05c.jpg";